import { render } from "./MedicalConditionsEditor.vue?vue&type=template&id=16da663e&scoped=true"
import script from "./MedicalConditionsEditor.vue?vue&type=script&lang=js"
export * from "./MedicalConditionsEditor.vue?vue&type=script&lang=js"

import "./MedicalConditionsEditor.vue?vue&type=style&index=0&id=16da663e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16da663e"]])

export default __exports__